import o from "./highrise1419.mjs";
import e from "./highrise1605.mjs";
import a from "./highrise661.mjs";
import n from "./highrise1321.mjs";
var p = /[\\^$.*+?()[\]{}|]/g, i = /^\[object .+?Constructor\]$/, s = Function.prototype, c = Object.prototype, f = s.toString, m = c.hasOwnProperty, u = RegExp(
  "^" + f.call(m).replace(p, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function O(r) {
  if (!a(r) || e(r))
    return !1;
  var t = o(r) ? u : i;
  return t.test(n(r));
}
export {
  O as default
};
